<div class="login-container">
  <div [ngClass]="isFirsResponderLogin ? 'col-6' : ''" class="login-module ">
    <div class="login-logo">
      <img src="assets/images/MWP_Blue_Main_Logo.webp" alt="My workplace logo" />
    </div>
    @if (isFAQ) {
      <div class="faq-container">
      @if (title) {
        <div class="header">
          <div class="title w-100">
            <mwp-text-translate [text]="title" [jsonKey]="jsonKeyTitle" />
          </div>
        </div>
      }
      <mwp-login-faq [LoginType]="loginType" />
      </div>
    } @else {
      @if (title) {
        <div class="header">
          <div class="title">
            <mwp-text-translate [text]="title" [jsonKey]="jsonKeyTitle" />
          </div>
        </div>
      }
      <div class="login-form-container">
        <div class="login-form">
          @switch (selectedLoginMode) {
            @case (loginMode.Credenttials) {
              <mwp-login-form [LoginType]="loginType" (emitBaseMemberSession)="buildSelectMember($event)" (emitMultiFactorAuthenticator)="buildMFA($event)" />
            }
            @case (loginMode.CredenttialsCounselor) {
              <mwp-login-form-counselor (emitMultiFactorAuthenticator)="buildMFA($event)" />
            }
            @case (loginMode.ResetPassword) {
              <mwp-register [isFirstResponder]="isFirsResponderLogin" [IsResetPassword]="true" /> 
            }
            @case (loginMode.Registration) {
              <mwp-register [isFirstResponder]="isFirsResponderLogin" /> 
            }
            @case (loginMode.Passthrough) {
              <div class="login-form-message mb-3">
                <div class="message-instructions mb-3">
                  <mwp-text-translate [text]="loginFormMessage" [jsonKey]="jsonKeyMessage" />
                </div>
              </div>
              <mwp-passthrough/>
            }
            @case (loginMode.MFA) {
              <mwp-mfa [multiFactorAuthenticator]="baseMultiFactorAuthenticator" (emitMultiMemberSelectResult)="buildSelectMember($event)" (cancel)="cancelLogin()" />
            }
            @case (loginMode.SelectAccount) {
              <mwp-multi-member-select [baseMemberSessionList]="baseMemberSession" [isLogin]="true" (cancel)="cancelSelectMember()" (submit)="submitMemberSelect($event)" />
            }
            @case (loginMode.AccountDeleted) {
              <div class="login-form-message mb-3">
                <div class="message-instructions mb-3">
                  <mwp-text-translate [text]="loginFormMessage" [jsonKey]="jsonKeyMessage" />
                </div>
                <div>
                  <button class="mwp-button" (click)="redirectToLogin()">
                    <mwp-text-translate text="Continue" jsonKey="continue" />
                  </button>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>